var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8 12.0004H2C1.00467 12.0004 0 11.2444 0 9.55642V6.19641C0.0140181 4.66453 0.587618 3.19062 1.61278 2.05224C2.63795 0.913865 4.04394 0.189569 5.566 0.0157476C6.42491 -0.0466029 7.28717 0.0766686 8.0942 0.377186C8.90123 0.677703 9.63412 1.14842 10.2431 1.75736C10.852 2.3663 11.3227 3.09918 11.6232 3.90621C11.9237 4.71324 12.047 5.57551 11.9847 6.43442C11.8106 7.95709 11.0857 9.36355 9.94653 10.3888C8.80734 11.414 7.33254 11.9872 5.8 12.0004ZM13.3333 6.05375H13.3253C13.3253 6.21175 13.3253 6.36975 13.3173 6.52842C13.06 10.1337 9.76467 13.1858 6.056 13.3211V13.3311C6.52307 14.1412 7.19491 14.8142 8.00415 15.2827C8.81339 15.7512 9.73159 15.9987 10.6667 16.0004H14C14.5304 16.0004 15.0391 15.7897 15.4142 15.4146C15.7893 15.0396 16 14.5308 16 14.0004V10.6671C15.999 9.73181 15.7522 8.81324 15.2841 8.00352C14.8161 7.19379 14.1433 6.52138 13.3333 6.05375Z",
    fill: "#2F4858"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.b1902f01f22c25d00ccac30b77965b22.svg";
export { ForwardRef as ReactComponent };